import {IDMap, ModelID} from "../generic-types";
import {ColumnFormatsConfig} from "../../forms/table-column-menu/table-column-menu.component";
import {ConstantValue} from "../../_models/api/generic-constant";
import {ConstantProperty, isConstantProperty} from "../../_models/constant-property";
import {ComponentType} from "../../_models/component-type";
import {ConditionalFormattingConfig} from "../../services/conditional-formatting.service";
import {WireComponent} from "../../_models/component";
import {ConfigStub} from "../config-stub";

/** Lives with its only caller so this module holds no runtime dependency on a
 *  component: the forms that render these columns import this one. */
export function isAttributeColumn(object): object is string {
    return typeof object === 'string';
}

export type ConfigColumnDefaultValue=ConstantValue | ConfigStub<WireComponent> | ConfigStub<WireComponent>[] | null;
export class ConfigColumn {
    id: ModelID;
    name?: string;
    title?: string;
    type: string;
    format?: ColumnFormatsConfig;
    column_name?: string;
    disabled?: boolean;
    required?: boolean;
    default_value?: ConfigColumnDefaultValue;
    filters?: string[];
}

export class EventConfigColumn extends ConfigColumn {
    conditional_format?: ConditionalFormattingConfig[];
    index?: number;
    related_type?: string;
    related_type_id?: ModelID;

    constructor(object: ConstantProperty | ComponentType | string, type: string, parentObject?: ComponentType) {
        super();
        this.type = type;
        this.required = false;
        this.disabled = false;
        this.format = {};
        if (isAttributeColumn(object)) {
            this.id = object;
            this.title = object;
        } else if (isConstantProperty(object)) {
            this.id = object.id;
            this.title = object.attributes.alias ? object.attributes.alias : object.attributes.name.replace(/_/g, " ");
        } else {
            this.id = object.id;
            this.title = object.attributes.name.replace(/_/g, " ");
        }
        if (parentObject) {
            this.related_type = parentObject.type;
            this.related_type_id = parentObject.id;
            const parentName =  parentObject.attributes.name.replace(/_/g, " ");
            this.title = `${parentName}:${this.title}`;
        }
    }
}
